import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IdentifyPopupComponent } from './identify-popup/identify-popup.component';
import { CoordinatesPopupComponent } from './coordinates-popup/coordinates-popup.component';
import { PopupService } from './service/popup.service';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [IdentifyPopupComponent, CoordinatesPopupComponent],
  providers: [PopupService],
})
export class PopupModule {}
